<template>
  <vxe-modal v-model="visible" :title="title" type="confirm" width="40%" @confirm="confirm">
    <vxe-card v-if="selectType==='checkbox'">
      <vxe-button icon="vxe-icon-square-close" mode="text" status="danger" @click="closeTag()"/>
      <vxe-tag v-for="row in selectedRows" :key="row.id" :content="row.name.length>8?row.name.slice(0,8)+'...':row.name" :title="row.name" closable color="blue" @close="closeTag(row)"/>
    </vxe-card>
    <vxe-table
      ref="table"
      :data="data"
      :loading="loading"
      :min-height="500"
      :maxHeight="700"
      :row-config="{useKey:true, keyField: 'id'}"
      @checkbox-all="({checked})=>checkAll(checked)"
      @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column :type="selectType" fixed="left" width="40"/>
      <vxe-column v-if="showNo" field="no" title="business.label.no"/>
      <vxe-column v-if="showName" field="name" title="business.label.name"/>
      <vxe-column v-if="showValue" field="value" title="business.label.value"/>
    </vxe-table>
  </vxe-modal>
</template>

<script>
import { findOne } from '@/api/Api'

export default {
  props: {
    selectType: { type: String, default: 'radio' },
    no: { type: String },
    title: { type: String, default: '' },
    showName: { type: Boolean, default: true },
    showNo: { type: Boolean, default: true },
    showValue: { type: Boolean, default: true }
  },
  data() {
    return {
      visible: false,
      loading: false,
      data: [],
      query: { no: '' },
      args: null,
      record: undefined,
      selectedRows: []
    }
  },
  methods: {
    init(args) {
      this.query = { 'no': '' }
      this.data = []
      this.selectedRows = []
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e, selectedRows) {
      this.init(args)
      this.record = e
      if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
      }
      this.visible = true
      this.refresh()
    },
    refresh() {
      this.loading = true
      this.query.no = this.no
      findOne('fieldFactory', this.query).then(res => {
        if (res.success) {
          this.data = res.result.dictionaries
          if (this.selectedRows.length > 0) {
            this.$refs.table.setCheckboxRow(this.selectedRows, true)
          }
        }
      }).finally(() => this.loading = false)
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        const radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
        } else {
          selectedRows = this.$refs.table.getCheckboxRecords()
        }
      }
      if (selectedRows.length > 0) this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    closeTag(row) {
      if (row) {
        this.$refs.table.setCheckboxRow(row, false)
      } else {
        this.$refs.table.clearCheckboxRow()
      }
      this.removeSelectedRow(row)
    },
    addTag(row) {
      if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
        this.selectedRows.push(row)
      }
    },
    removeSelectedRow(row) {
      if (row) {
        this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
      } else {
        this.selectedRows = []
      }
    },
    changeCheckbox(checked, row) {
      if (this.selectType === 'radio') {
        return
      }
      if (checked) {
        this.addTag(row)
      } else {
        this.removeSelectedRow(row)
      }
    },
    checkAll(checked) {
      this.data.forEach(item => {
        if (checked) {
          this.addTag(item)
        } else {
          this.closeTag(item)
        }
      })
    }
  }
}
</script>